
// Professional color palette with improved aesthetics and accessibility
export const SENDER_COLORS = [
  '#6366F1', // Indigo (primary)
  '#F59E0B', // Amber
  '#10B981', // Emerald
  '#EC4899', // Pink
  '#0EA5E9', // Sky Blue
  '#8B5CF6', // Violet
  '#14B8A6', // Teal
  '#F97316', // Orange
  '#8B5CF6', // Purple
  '#06B6D4'  // Cyan
];

// Gradient enhanced colors for pie chart with better visual appeal
export const FILE_TYPE_COLORS = [
  '#6366F1', // Indigo (primary)
  '#F97316', // Orange
  '#06B6D4', // Cyan
  '#8B5CF6', // Violet
  '#10B981', // Emerald
  '#F59E0B', // Amber
  '#EC4899', // Pink
];

// Background colors for cards and containers
export const BACKGROUND_COLORS = {
  primary: 'rgba(99, 102, 241, 0.08)',
  secondary: 'rgba(236, 72, 153, 0.08)',
  success: 'rgba(16, 185, 129, 0.08)',
  warning: 'rgba(245, 158, 11, 0.08)',
  info: 'rgba(14, 165, 233, 0.08)'
};
